// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"fd3c6904","183":"4b233d51","189":"597c04e9","220":"ee72b4b3","453":"41811d64","610":"9b9fb5f6","755":"77981823","777":"eca3e8f7","911":"1340a54c","961":"f309dd74"}[chunkId] + ".chunk.js";
};